import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom"; 
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthWrapper, LoginAuthWrapper } from "AuthWrapper";
import LoginScreen from "./pages/login";
import Settings from "pages/settings";
import OverviewDashboard from "pages/analytics/overview";
import FinanceLayout from "pages/finance/FinanceLayout";
import FinanceDashboard from "pages/finance/Dashboard";
import FinanceSalesPage from "pages/finance/SalesPage";
import FinanceExpensePage from "pages/finance/ExpensePage";
import FinanceExpenseAnalyticsPage from "pages/finance/ExpenseAnalyticsPage";
import FinanceCommissionsPage from "pages/finance/CommissionsPage";
import FunnelPerformance from "pages/funnel/FunnelPerformance";
import GhlPipeline from "pages/funnel/GhlPipeline";
import Ga4Page from "pages/analytics/traffic-attribution/Ga4Page";
import UtmLinksPage from "pages/analytics/traffic-attribution/UtmLinksPage";
import AttributionPage from "pages/analytics/traffic-attribution/AttributionPage";
import AttributionMappingsPage from "pages/analytics/traffic-attribution/AttributionMappingsPage";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Navigate to="/analytics/overview" replace />} />

          <Route
            path="/login"
            element={
              <LoginAuthWrapper>
                <LoginScreen />
              </LoginAuthWrapper>
            }
          />

          <Route
            path="/analytics/overview"
            element={
              <AuthWrapper>
                <OverviewDashboard />
              </AuthWrapper>
            }
          />
          <Route
            path="/finance"
            element={
              <AuthWrapper>
                <FinanceLayout />
              </AuthWrapper>
            }
          >
            <Route index element={<FinanceDashboard />} />
            <Route path="sales" element={<FinanceSalesPage />} />
            <Route path="expense" element={<FinanceExpensePage />} />
            <Route path="expense-analytics" element={<FinanceExpenseAnalyticsPage />} />
            <Route path="commissions" element={<FinanceCommissionsPage />} />
          </Route>
          <Route path="/analytics/finance" element={<Navigate to="/finance" replace />} />
          <Route path="/analytics/ghl-pipeline" element={<Navigate to="/funnel/ghl-pipeline" replace />} />
          <Route path="/analytics/internal-analytics" element={<Navigate to="/funnel/performance" replace />} />
          <Route path="/analytics/sales-funnel" element={<Navigate to="/funnel/performance" replace />} />
          <Route path="/funnel" element={<Navigate to="/funnel/performance" replace />} />
          <Route path="/analytics/expenses" element={<Navigate to="/finance/expense-analytics" replace />} />
          <Route path="/analytics/traffic-attribution" element={<Navigate to="/analytics/attribution" replace />} />
          <Route path="/analytics/traffic-attribution/utm-links" element={<Navigate to="/analytics/utm-links" replace />} />
          <Route path="/analytics/traffic-attribution/attribution" element={<Navigate to="/analytics/attribution" replace />} />
          <Route path="/analytics/traffic-attribution/attribution-mappings" element={<Navigate to="/analytics/attribution-mappings" replace />} />
          <Route path="/analytics/traffic-attribution/google-analytics" element={<Navigate to="/analytics/google-analytics" replace />} />
          <Route path="/analytics/ads-lead-analytics" element={<Navigate to="/analytics/attribution" replace />} />
          <Route path="/sales" element={<Navigate to="/finance/sales" replace />} />
          <Route path="/expense" element={<Navigate to="/finance/expense" replace />} />
          <Route path="/dashboard-overview" element={<Navigate to="/analytics/overview" replace />} />
          <Route
            path="/funnel/performance"
            element={
              <AuthWrapper>
                <FunnelPerformance />
              </AuthWrapper>
            }
          />
          <Route
            path="/funnel/ghl-pipeline"
            element={
              <AuthWrapper>
                <GhlPipeline />
              </AuthWrapper>
            }
          />
          <Route
            path="/analytics/google-analytics"
            element={
              <AuthWrapper>
                <Ga4Page />
              </AuthWrapper>
            }
          />
          <Route
            path="/analytics/utm-links"
            element={
              <AuthWrapper>
                <UtmLinksPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/analytics/attribution"
            element={
              <AuthWrapper>
                <AttributionPage />
              </AuthWrapper>
            }
          />
          <Route
            path="/analytics/attribution-mappings"
            element={
              <AuthWrapper>
                <AttributionMappingsPage />
              </AuthWrapper>
            }
          />

          <Route path="/analytics" element={<Navigate to="/analytics/overview" replace />} />

          <Route
            path="/settings"
            element={
              <AuthWrapper>
                <Settings />
              </AuthWrapper>
            }
          />

          <Route
            path="*"
            element={
              <AuthWrapper>
                <NotFound />
              </AuthWrapper>
            }
          />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
